import script from "./Step2SellerCreation.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2SellerCreation.vue?vue&type=script&setup=true&lang=js"

import "./Step2SellerCreation.vue?vue&type=style&index=0&id=25865bf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25865bf8"]])

export default __exports__